import script from "./DeadlineTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineTable.vue?vue&type=style&index=0&id=21472d0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21472d0a"]])

export default __exports__